export default __webpack_public_path__ + "static/media/parceiro_transportadora.45b14b9f.svg";